var map = {
	"./alumno-certificado-sep-fundacion-nican.png": 264,
	"./alumnos-con-diploma-fundacion-nican.png": 62,
	"./aprende-masoterapia-profesional-edomex.png": 4487,
	"./capacitacion-avalada-sep-ixtapaluca.png": 5385,
	"./curso-auxiliar-enfermeria-ixtapaluca.png": 3829,
	"./curso-terapeutico-certificado-sep.png": 3934,
	"./diploma-curso-profesional-fundacion-nican.png": 6015,
	"./escuela-certificaciones-profesionales-edomex.png": 2691,
	"./escuela-de-formacion-ixtapaluca.png": 8247,
	"./formacion-profesional-ixtapaluca-fundacion-nican.png": 3987,
	"./fundacion-nican-centro-capacitacion-ixtapaluca.png": 5565,
	"./institucion-educativa-fundacion-nican.png": 9353,
	"./preparacion-profesional-para-empleo-edomex.png": 8847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1354;